export default __webpack_public_path__ + "static/media/main_page_img.11921b3b.png";